export default {
	ACTION_TYPE_ERROR: 'resource__ERROR',
};
